export default __webpack_public_path__ + "static/media/dropdown_arrow_red.4a079eef.svg";